import {
  ActivatedRoute,
  GuardsCheckEnd,
  GuardsCheckStart,
  NavigationCancel,
  NavigationEnd,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AfterViewInit, Component, Inject, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { RegionService } from './region.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';

import * as AOS from 'aos';
import { AuthService } from './auth.service';
import { FirstPromoterService } from './first-promoter.service';
import { CleverTapService } from './clevertap.service';

declare global {
  interface Window {
    HubSpotConversations: any;
    hsConversationsOnReady: Array<() => void>;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'Uptal';
  loadingDataImg: boolean = false;
  loading = true;

  lang = 'en';
  ltrrtl = 'ltr';

  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private regionService: RegionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private firstPromoter: FirstPromoterService,
    private cleverTap: CleverTapService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    const icons = [
      'ai-brain',
      'ai-browser',
      'ai-camera',
      'ai-magic',
      'ai-search',
      'ai-user',
      'zap',
      'riyal',
      'logo-white',
      'sa-flag',
    ] as const;
    icons.forEach((icon) => {
      this.matIconRegistry.addSvgIcon(
        icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${icon}.svg`,
        ),
      );
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      AOS.init({ easing: 'ease-in-out', once: true });
      this.loadSupportChat();
      // initialNavigation: 'enabledBlocking' completes before AppComponent mounts,
      // so the initial NavigationEnd has already fired by the time ngAfterViewInit
      // subscribes. Kick the HubSpot toggle off here with the resolved URL.
      this.toggleHubSpotChat(this.router.url);
      // Referral click tracking — promoter links land on this site.
      this.firstPromoter.init();
      // Lifecycle marketing. Anonymous until the checkout knows who this is;
      // CleverTap merges the session into the real profile at that point.
      this.cleverTap.init();
    }
  }

  // Uptal's own live-chat widget (helpdesk-backed) — env-aware snippet.
  loadSupportChat() {
    const script = this.document.createElement('script');
    script.src = `${environment.apiUrl}widget/chat.js`;
    script.defer = true;
    this.document.body.appendChild(script);
  }

  // Show the HubSpot chat widget only on /talent-search, hide it everywhere else.
  // The loader script runs with `loadImmediately: false` (see index.html), so the
  // widget only mounts when we explicitly call `.load()`.
  toggleHubSpotChat(url: string) {
    const shouldShow = url.split('?')[0].split('#')[0] === '/talent-search';
    const apply = () => {
      const widget = window.HubSpotConversations?.widget;
      if (!widget) return;
      if (shouldShow) {
        widget.load();
      } else {
        widget.remove();
      }
    };

    if (window.HubSpotConversations?.widget) {
      apply();
    } else {
      window.hsConversationsOnReady = window.hsConversationsOnReady || [];
      window.hsConversationsOnReady.push(apply);
    }
  }

  // collect that title data properties from all child routes
  // there might be a better way but this worked for me
  getTitle(state, parent) {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event) => {
        if (event instanceof GuardsCheckStart) this.loading = true;
        if (
          event instanceof GuardsCheckEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationEnd
        )
          this.loading = false;
      });

      //Add dynamic title for selected pages - Start
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.toggleHubSpotChat(event.urlAfterRedirects);
          // var title = this.getTitle(
          //   this.router.routerState,
          //   this.router.routerState.root
          // ).join(' > ');
          // this.titleService.setTitle(title);
        }
      });
    }
  }
}
